import { connect } from 'react-redux';

import { IApplicationState } from 'shared/types/redux';
import { getCoworkingPageTitle } from 'shared/utils/getCoworkingPageTitle';

import { Title as TitleComponent } from './Title';
import { ITitleProps } from './types';

export const mapStateToProps = (state: IApplicationState): ITitleProps => ({
  coworkingName: getCoworkingPageTitle(state.coworking),
});

export const Title = connect(mapStateToProps)(TitleComponent);
